// password conceal/reveal feature
// requirements: 
//  * div containing only an input of type "password", and a button
//  * div has "js-conceal-pass" attribute
//  * button has "js-conceal-pass-cta" attribute
//  * button optionally contains two "js-conceal-pass-icon" elements with values of "visibility" and "unvisibility"
// example markup:
// <div js-conceal-pass>
// <input type="password" />
// <button>reveal</button>
// </div>
export const concealPass = () => {
    const passFields = document.querySelectorAll("[js-conceal-pass]");

    passFields.forEach((field) => {
        const passInput = field.querySelector("input") as HTMLInputElement;
        const concealCta = field.querySelector("button[js-conceal-pass-cta]") as HTMLButtonElement;
        const concealIcons = concealCta.querySelectorAll("[js-conceal-pass-icon]");

        const setAria = (isPass: boolean) => concealCta.setAttribute("aria-label", `${isPass ? "Show" : "Hide"} password`);
        const isPass = () => passInput.type == "password";
        const setIcons = () => {
            const toShow = isPass() ? "visibility" : "unvisibility";
            const toHide = isPass() ? "unvisibility" : "visibility";

            concealCta.querySelector(`[js-conceal-pass-icon='${toShow}']`)?.classList.remove("display--n");
            concealCta.querySelector(`[js-conceal-pass-icon='${toHide}']`)?.classList.add("display--n");
        }

        if (concealCta) {
            concealCta.addEventListener("click", (event: Event) => {
                event.preventDefault();
                
                if (passInput) {
                    passInput.type = isPass() ? "text" : "password";    
                }

                if (concealIcons && !!concealIcons.length) {
                    setIcons();
                }

                setAria(isPass());
            });
        }

        if (concealIcons && concealIcons.length) {
            setIcons();
        }

        setAria(isPass());
    });
};